export type ChatMessages = ChatMessage[];

export class ChatMessage {
  id: number;
  mr_id: number; // Maintenance Request ID
  sender_id: number;
  created_at: Date;
  updated_at: Date;
  text: string;
  read: number; // 0 for unread, 1 for read.

  constructor(init?: Partial<ChatMessage>) {
    Object.assign(this, init);
  }
}